<template>
    <ac-modal :title="modalType + ' ' + dependentType" ref="modal">
        <template v-if="widgetReady">
            <div>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label style="width: 100%">First Name
                                <small><span class="redText">required </span></small>
                                <input type="text" name="firstName" class="form-control" placeholder="First Name" v-model="vm.contactInfo.firstName">
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="form-group">
                            <label style="width: 100%">
                                MI
                                <input type="text" name="middleInitial" class="form-control" placeholder="Middle Initial" v-model="vm.contactInfo.middleInitial">
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label style="width: 100%">Last Name
                                <small><span class="redText">required </span></small>
                                <input type="text" name="lastName" class="form-control" placeholder="Last Name" v-model="vm.contactInfo.lastName">
                            </label>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label style="width: 100%" v-if="genders.length>0">
                                Gender
                                <select v-model="vm.contactInfo.genderCode" type="text" class="form-control">
                                    <option v-for="gender in genders" :value="gender.genderCode">
                                        {{gender.genderName}}
                                    </option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group">
                            <label>DOB <small><span class="redText">required </span></small></label><br/>
                            <ac-date-picker v-model="vm.birthDate">

                            </ac-date-picker>
                        </div>
                    </div>
                </div>
            </div><!--/close overview-scroll-->
        </template>
        <template slot="buttons">
            <div>
                <ac-button class="btn btn-red btn-sm" :action="cancel">
                    CANCEL
                </ac-button>&nbsp;
                <ac-button class="btn btn-green btn-sm" :action="addDependent">
                    <span style="text-transform: uppercase">SAVE {{dependentType}}</span>
                </ac-button>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {configTables} from "../../../../global/configTables.js";

    export default {
        name: "AddDependentModal",
        data() {
            return {
                widgetReady: false,
                isSpouse: false,
                vm: {},
                genders: [],
                titles: [],
                editMode: false,
            }
        },
        computed: {
            dependentType() {
                return this.isSpouse ? 'Spouse' : 'Dependent'
            },
            modalType() {
                return this.editMode ? 'Edit' : 'Add'
            }
        },
        async mounted() {
            configTables.getGenders().then((genders) => {
                this.genders = genders;
            });
            configTables.getTitles().then((titles) => {
                this.titles = titles;
            });
        },
        methods: {
            cancel() {
                this.$refs.modal.close();
            },
            async addDependent() {
                let result = await api.post('ProviderSearch', 'ValidateDependent', this.vm, true);
                if (result) {
                  let vmCopy=this.clone(this.vm);
                  this.$emit(this.editMode ? "onDependentEdited":"onDependentAdded", {...vmCopy, isSpouse: this.isSpouse});
                  this.$refs.modal.close();
                }
            },
            async showModal({isSpouse, address}) {
                this.isSpouse = isSpouse;
                let action = isSpouse ? "GetSpouseTemplate" : "GetChildTemplate";
                let template = await api.getData('ProviderSearch', '', action);
                template.address = this.clone(address);
                template.contactInfo.genderCode = this.genders[0].genderCode;
                template.contactInfo.titleId = null;
                this.mapData('vm', template);
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            async editModal(dependent) {
              this.widgetReady = false;
              this.editMode = true;
              this.isSpouse = dependent.isSpouse;
              this.mapData('vm', dependent);
              this.widgetReady = true;
              this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>

</style>